import { createAction } from '@reduxjs/toolkit';

export const ADD_CALL_SESSION_ACTION_TYPE = 'saga/addCallSession';
export const addCallSessionAction = createAction(ADD_CALL_SESSION_ACTION_TYPE);
